<template>
  <div class="business-income-sources bg--color-11">
    <div class="container-wrapper bg--color-01">
      <div class="business-income-sources__container container-new">
        <span
          class="txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold txt--center--m"
        >
          {{ $t('business.incomeSources.title') }}
        </span>

        <span
          class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-04 txt--center--m"
        >
          {{ $t('business.incomeSources.desc') }}
        </span>

        <div class="business-income-sources__cols mt-24 mt-32--m">
          <img
            src="@/assets/img/business/income-sources/main.svg"
            class="business-income-sources__img"
          >

          <div class="business-income-sources__items">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="business-income-sources__item"
            >
              <div
                class="business-income-sources__circle"
                :style="{ 'background-color': item.color }"
              />

              <span
                class="txt txt--16px txt--height-24px txt--22px--m txt--height-30px-m txt--color-04"
              >{{ item.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    items () {
      return [
        {
          text: this.$t('business.incomeSources.items.0'),
          color: 'rgba(213, 181, 255, 1)',
        },
        {
          text: this.$t('business.incomeSources.items.1'),
          color: 'rgba(255, 135, 197, 1)',
        },
        {
          text: this.$t('business.incomeSources.items.2'),
          color: 'rgba(174, 204, 248, 1)',
        },
        {
          text: this.$t('business.incomeSources.items.3'),
          color: 'rgba(255, 186, 242, 1)',
        },
        {
          text: this.$t('business.incomeSources.items.4'),
          color: 'rgba(255, 232, 108, 1)',
        },
        {
          text: this.$t('business.incomeSources.items.5'),
          color: 'rgba(79, 209, 139, 1)',
        },
        {
          text: this.$t('business.incomeSources.items.6'),
          color: 'rgba(255, 172, 122, 1)',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.business-income-sources {
  &__container {
    display: flex;
    flex-direction: column;
    gap: toRem(24px);
  }

  &__cols {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(40px);

    @include bp(m) {
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: toRem(70px);

      position: relative;

      &::after {
        content: '';
        background: url('@/assets/img/business/income-sources/star.svg');
        background-position: center;
        background-repeat: no-repeat;
        width: toRem(49px);
        height: toRem(109px);
        position: absolute;
        z-index: 5;
        display: block;
        top: 22%;
        margin: auto 0;
        left: toRem(-32px);
      }
    }

    // @include bp(l) {
    //   grid-template-columns: 3fr 2fr;
    // }
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: toRem(22px);

    @include bp(m) {
      gap: toRem(27px);
    }
  }

  &__img {
    width: 100%;
    margin: 0 auto;

    @include bp(0, m) {
      max-width: toRem(400px);
    }

    @include bp(m) {
      max-width: toRem(600px);
      margin: unset;
    }
  }

  &__item {
    display: grid;
    grid-template-columns: toRem(17px) 1fr;
    align-items: center;
    gap: toRem(16px);
  }

  &__circle {
    width: toRem(17px);
    height: toRem(17px);
    border-radius: 100%;
  }
}
</style>
